function initReadMore() {
  document.querySelectorAll(".athlete-description").forEach(section => {
    // Prevent double-init if Shopify reloads the section
    if (section.dataset.readmoreInit === "1") return;
    section.dataset.readmoreInit = "1";

    const btn = section.querySelector(".read-more-btn");
    const shortText = section.querySelector(".short-text");
    const fullText  = section.querySelector(".full-text");

    if (!btn || !shortText || !fullText) return;

    // Set initial state to match DOM/CSS (in case .expanded is present server-side)
    const initiallyExpanded = section.classList.contains("expanded");
    shortText.style.display = initiallyExpanded ? "none"  : "";
    fullText.style.display  = initiallyExpanded ? "block" : "none";
    btn.textContent = initiallyExpanded ? "Show less" : "Read more";

    btn.addEventListener("click", () => {
      const expanded = section.classList.toggle("expanded");

      // Force the switch with inline styles so it works regardless of other CSS
      if (expanded) {
        fullText.style.display  = "block";
        shortText.style.display = "none";
        btn.textContent = "Show less";
      } else {
        fullText.style.display  = "none";
        shortText.style.display = ""; // let CSS decide (or default block)
        btn.textContent = "Read more";
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", initReadMore);
document.addEventListener("shopify:section:load", initReadMore);
